module.exports = __webpack_public_path__ + "img/1576855719.29a69059.jpg";